export const MainServiceSectionCaulkingSealantRenewal = {
    "imageUrl": "/assets/imgs/services/2Caulking&SealantRenewal/fondo.jpg",
    "eyebrow": "Caulking & Sealant",
    "title": "Renewals",
    "headingSpan": "PROTECTING YOUR BUILDING",
    "heading": "FROM THE ELEMENTS",
    "description": "Over time, caulking and sealants degrade due to exposure to UV rays, moisture, temperature fluctuations, and general wear and tear. Failing sealants can lead to water infiltration, air leaks, and energy loss, compromising your building’s structural integrity and efficiency.At HRD Painting & Restoration, we specialize in professional caulking and sealant renewals to ensure your building remains watertight, airtight, and energy-efficient.",
    "highlightSpan": "The best Building Envelope Renewal",
    "highlight": " / High-Rise Painting & Restoration services.",
    "button": {
        "text": "Request a Quote",
        "url": "/quote"
    }
};